import firebase from "firebase";

var firebaseConfig = {
  apiKey: "AIzaSyDCC2DH4VL1TCO9m-eqhQLJnUx8li26jLk",
  authDomain: "mmddesigne.firebaseapp.com",
  projectId: "mmddesigne",
  storageBucket: "mmddesigne.appspot.com",
  messagingSenderId: "475825936411",
  appId: "1:475825936411:web:e16aac6ff9a3fef45600be",
};

firebase.initializeApp(firebaseConfig);

const storage = firebase.storage();

export { storage, firebase as default };
